import userReducer from "./reducer"
import userSagas from "./sagas"

const saga = {
  reducers: userReducer,
  sagas: userSagas
}

export default saga